import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Divider } from "@mui/material";
import { categoryListFn } from "../../Services/CategoryList";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";


function Sub() {
    const {id} =useParams();
    const navigate = useNavigate()
    const { data: mainCategoryList } = useQuery(
        ["mainCategoryList" ,id],
        () => categoryListFn(),
        {
          refetchOnMount: false,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
        }
      );

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 2 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box className="flex bg-gray-100 !border-gray-100">
            <Tabs
              className=""
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: "divider" }}
            >
              <Tab
                className="!capitalize"
                label={
                  <>
                    <div className="">
                    {mainCategoryList?.data?.data?.main_category_list?.map((product) => {
          return (
            <> <span className=" truncate">{product.category}</span>
             {product?.sub_category_list?.map((subcategory)=>{
                return<>
                <div
                        key={subcategory.id}
                        className="p-2 flex flex-col gap-2 cursor-pointer hover:underline"
                        onClick={() =>
                          navigate(`/all-products`, {
                            state: {
                              from: "subCategory",
                              subCategory: subcategory.id,
                            },
                          })
                        }
                      >
                        {subcategory.subcategory}
                      </div>
                </>
             })}
            </>
          );
        })}
                    </div>
                  </>
                  
                }
                {...a11yProps(0)}
              />
            
            </Tabs>

            <div className="!w-80">
              <TabPanel value={value} index={0} className="!p-0">
                <p className="py-2 ">Matress</p>
                <Divider />
                <p className="py-2">Plus Matress</p>
                <Divider />
                <p className="py-2 ">Matress</p>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <p className="py-2 ">Matress</p>
                <Divider />
                <p className="py-2">Plus Matress</p>
                <Divider />
                <p className="py-2 ">Matress</p>
              </TabPanel>
           
            </div>
          </Box>
    </div>
  );
}

export default Sub
